import { __decorate, __param } from 'tslib';
import { TemplateRef, Inject, Directive, InjectionToken, ElementRef, Optional, HostBinding, Component, ChangeDetectionStrategy, EventEmitter, Renderer2, ChangeDetectorRef, ContentChildren, forwardRef, Input, Output, HostListener, ViewChild, NgZone, NgModule } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { TuiDestroyService, TuiFocusVisibleService, typedFromEvent, tuiCustomEvent, isNativeFocused, setNativeFocused, TUI_IS_IOS, TUI_IS_ANDROID, EMPTY_QUERY, moveFocus, TuiResizeService, tuiDefaultProp, tuiAssertIsHTMLElement, getClosestFocusable, toInt, tuiZonefree, px, TuiFocusableModule } from '@taiga-ui/cdk';
import { TuiRouterLinkActiveService, MODE_PROVIDER, TUI_MODE, TuiHostedDropdownModule, TuiSvgModule } from '@taiga-ui/core';
import { TUI_TAB_MARGIN, TUI_MOBILE_AWARE, TUI_MORE_WORD } from '@taiga-ui/kit/tokens';
import { EMPTY, merge, identity, Observable, ReplaySubject, of } from 'rxjs';
import { DOCUMENT, CommonModule } from '@angular/common';
import { MutationObserverService, MUTATION_OBSERVER_INIT } from '@ng-web-apis/mutation-observer';
import { filter, map, tap, debounceTime, startWith, takeUntil, switchMap, mapTo, share } from 'rxjs/operators';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { ANIMATION_FRAME } from '@ng-web-apis/common';
import { asCallable } from '@tinkoff/ng-event-plugins';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from 'rxjs';
import * as ɵngcc4 from '@taiga-ui/cdk';
import * as ɵngcc5 from '@taiga-ui/core';
import * as ɵngcc6 from '@tinkoff/ng-polymorpheus';

const _c0 = ["tuiTab", ""];
function TuiTabComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c1 = ["*"];
function TuiTabsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiTabsComponent_tui_underline_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-underline", 2);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("element", ctx_r1.activeElement);
} }
function TuiTabsWithMoreComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiTabsWithMoreComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 12);
} if (rf & 2) {
    const item_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r7);
} }
function TuiTabsWithMoreComponent_ng_container_4_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiTabsWithMoreComponent_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, TuiTabsWithMoreComponent_ng_container_4_ng_template_2_ng_container_1_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    const index_r8 = ctx_r14.index;
    const item_r7 = ctx_r14.$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("t-overflown", ctx_r11.isOverflown(index_r8));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r7);
} }
function TuiTabsWithMoreComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiTabsWithMoreComponent_ng_container_4_ng_container_1_Template, 1, 1, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(2, TuiTabsWithMoreComponent_ng_container_4_ng_template_2_Template, 2, 3, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const index_r8 = ctx.index;
    const _r10 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", index_r8 <= ctx_r1.lastVisibleIndex)("ngIfElse", _r10);
} }
function TuiTabsWithMoreComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelement(2, "tui-svg", 14);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(1, 3, ctx_r3.moreWord$), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("t-icon_rotated", ctx_r3.open);
} }
function TuiTabsWithMoreComponent_ng_template_10_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 12);
} if (rf & 2) {
    const item_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r17);
} }
function TuiTabsWithMoreComponent_ng_template_10_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("tui-tab-activate", function TuiTabsWithMoreComponent_ng_template_10_div_2_Template_div_tui_tab_activate_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r22); const index_r18 = restoredCtx.index; const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.onClick(index_r18); });
    ɵngcc0.ɵɵtemplate(1, TuiTabsWithMoreComponent_ng_template_10_div_2_ng_container_1_Template, 1, 1, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r18 = ctx.index;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.shouldShow(index_r18));
} }
function TuiTabsWithMoreComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15, 16);
    ɵngcc0.ɵɵlistener("keydown.arrowUp.prevent", function TuiTabsWithMoreComponent_ng_template_10_Template_div_keydown_arrowUp_prevent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const _r15 = ɵngcc0.ɵɵreference(1); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onWrapperArrow($event, _r15, true); })("keydown.arrowDown.prevent", function TuiTabsWithMoreComponent_ng_template_10_Template_div_keydown_arrowDown_prevent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const _r15 = ɵngcc0.ɵɵreference(1); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.onWrapperArrow($event, _r15, false); });
    ɵngcc0.ɵɵtemplate(2, TuiTabsWithMoreComponent_ng_template_10_div_2_Template, 2, 1, "div", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.items);
} }
function TuiTabsWithMoreComponent_tui_underline_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-underline", 20);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("element", ctx_r6.activeElement);
} }
let TuiTabDirective = class TuiTabDirective {
    constructor(template) {
        this.template = template;
    }
};
TuiTabDirective.ɵfac = function TuiTabDirective_Factory(t) { return new (t || TuiTabDirective)(ɵngcc0.ɵɵdirectiveInject(TemplateRef)); };
TuiTabDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTabDirective, selectors: [["ng-template", "tuiTab", ""]] });
TuiTabDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Inject, args: [TemplateRef,] }] }
];
TuiTabDirective = __decorate([ __param(0, Inject(TemplateRef))
], TuiTabDirective);

const TUI_TAB_ACTIVATE = 'tui-tab-activate';
const TUI_TAB_EVENT = new InjectionToken('Stream of tab activation events');
const TUI_TAB_PROVIDERS = [
    TuiDestroyService,
    TuiFocusVisibleService,
    TuiRouterLinkActiveService,
    {
        provide: TUI_TAB_EVENT,
        deps: [
            ElementRef,
            DOCUMENT,
            TuiRouterLinkActiveService,
            [new Optional(), MutationObserverService],
            [new Optional(), RouterLinkActive],
        ],
        useFactory: tabActiveFactory,
    },
    MODE_PROVIDER,
];
function tabActiveFactory({ nativeElement }, documentRef, routerLinkActiveService, mutationObserverService, routerLinkActive) {
    const mutationObserver = routerLinkActive && mutationObserverService
        ? mutationObserverService.pipe(filter(() => routerLinkActive.isActive))
        : EMPTY;
    return merge(mutationObserver, routerLinkActiveService.pipe(filter(identity)), nativeElement.matches('button') ? typedFromEvent(nativeElement, 'click') : EMPTY).pipe(map(() => nativeElement.dispatchEvent(tuiCustomEvent(TUI_TAB_ACTIVATE, { bubbles: true }, documentRef))));
}

let TuiTabComponent = class TuiTabComponent {
    constructor(routerLinkActive, elementRef, mode$, event$, margin, mobileAware, isIos, isAndroid, focusVisible$) {
        this.routerLinkActive = routerLinkActive;
        this.elementRef = elementRef;
        this.mode$ = mode$;
        this.event$ = event$;
        this.margin = margin;
        this.focusVisible = false;
        this.isIos = mobileAware && isIos;
        this.isAndroid = mobileAware && isAndroid;
        focusVisible$.subscribe(visible => {
            this.focusVisible = visible;
        });
    }
    get isActive() {
        return !!this.routerLinkActive && this.routerLinkActive.isActive;
    }
    ngOnDestroy() {
        if (isNativeFocused(this.elementRef.nativeElement)) {
            setNativeFocused(this.elementRef.nativeElement, false);
        }
    }
};
TuiTabComponent.ɵfac = function TuiTabComponent_Factory(t) { return new (t || TuiTabComponent)(ɵngcc0.ɵɵdirectiveInject(RouterLinkActive, 8), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TUI_MODE), ɵngcc0.ɵɵdirectiveInject(TUI_TAB_EVENT), ɵngcc0.ɵɵdirectiveInject(TUI_TAB_MARGIN), ɵngcc0.ɵɵdirectiveInject(TUI_MOBILE_AWARE), ɵngcc0.ɵɵdirectiveInject(TUI_IS_IOS), ɵngcc0.ɵɵdirectiveInject(TUI_IS_ANDROID), ɵngcc0.ɵɵdirectiveInject(TuiFocusVisibleService)); };
TuiTabComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiTabComponent, selectors: [["a", "tuiTab", "", 3, "routerLink", ""], ["a", "tuiTab", "", "routerLink", "", "routerLinkActive", ""], ["button", "tuiTab", ""]], hostAttrs: ["type", "button"], hostVars: 10, hostBindings: function TuiTabComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("$.data-mode.attr", function TuiTabComponent___data_mode_attr_HostBindingHandler() { return ctx.mode$; });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("--tui-tab-margin", ctx.margin, "px");
        ɵngcc0.ɵɵclassProp("_focus-visible", ctx.focusVisible)("_ios", ctx.isIos)("_android", ctx.isAndroid)("_active", ctx.isActive);
    } }, features: [ɵngcc0.ɵɵProvidersFeature(TUI_TAB_PROVIDERS)], attrs: _c0, ngContentSelectors: _c1, decls: 4, vars: 3, consts: [[4, "ngIf"], [1, "t-highlight"]], template: function TuiTabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiTabComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.event$));
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc1.AsyncPipe], styles: ["._underline[_nghost-%COMP%]:hover, ._underline   [_nghost-%COMP%]:hover{box-shadow:inset 0 -2px var(--tui-base-03)}[_nghost-%COMP%]{transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;position:relative;display:flex;flex-shrink:0;height:100%;box-sizing:border-box;justify-content:space-between;align-items:center;white-space:nowrap;cursor:pointer;outline:0;text-decoration:none;color:inherit;transition-property:color,box-shadow,opacity;margin-right:var(--tui-tab-margin,1.5rem)}[_nghost-%COMP%]:hover{color:var(--tui-text-01)}[_nghost-%COMP%]:disabled{opacity:var(--tui-disabled-opacity);pointer-events:none}[_nghost-%COMP%]:not([data-mode])._active{opacity:1;color:var(--tui-text-01);box-shadow:none}[data-mode=onDark][_nghost-%COMP%]{color:rgba(255,255,255,.72)}[data-mode=onDark]._active[_nghost-%COMP%], [data-mode=onDark][_nghost-%COMP%]:hover{color:#fff}[data-mode=onDark]._focus-visible[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{background:var(--tui-clear-inverse);color:var(--tui-text-01)}[data-mode=onLight][_nghost-%COMP%]{color:var(--tui-text-02)}[data-mode=onLight]._active[_nghost-%COMP%], [data-mode=onLight][_nghost-%COMP%]:hover{color:var(--tui-text-01)}[data-mode=onLight]._focus-visible[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{background:var(--tui-text-01);color:#fff}._focus-visible[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{background:var(--tui-selection)}._android[_nghost-%COMP%]{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;height:3rem;flex:1;flex-shrink:0;justify-content:center;margin:0;text-transform:uppercase;color:var(--tui-base-09);opacity:.5;font-size:.875rem;font-weight:500;letter-spacing:-.008125rem;font-family:-apple-system,BlinkMacSystemFont,Roboto,'Helvetica Neue',sans-serif}._android[_nghost-%COMP%]:hover{box-shadow:none}._android._active[_nghost-%COMP%]{opacity:1;color:var(--tui-base-09)}._android[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{width:auto}._ios[_nghost-%COMP%]{height:1.75rem;flex:1;flex-shrink:0;justify-content:center;margin:0;color:var(--tui-base-01);opacity:1;font-size:.8125rem;font-weight:500;letter-spacing:-.005rem;font-family:-apple-system,BlinkMacSystemFont,Roboto,'Helvetica Neue',sans-serif}._ios[_nghost-%COMP%]:hover{box-shadow:none}._ios._active[_nghost-%COMP%]{font-size:.875rem;font-weight:600;color:var(--tui-link)}._ios[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{width:auto}.t-highlight[_ngcontent-%COMP%]{display:inline-flex;width:100%;align-items:center;justify-content:inherit}.t-highlight[_ngcontent-%COMP%]    >*{flex-shrink:0}"], changeDetection: 0 });
TuiTabComponent.ctorParameters = () => [
    { type: RouterLinkActive, decorators: [{ type: Optional }, { type: Inject, args: [RouterLinkActive,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_MODE,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_TAB_EVENT,] }] },
    { type: Number, decorators: [{ type: Inject, args: [TUI_TAB_MARGIN,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_MOBILE_AWARE,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_IOS,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_ANDROID,] }] },
    { type: TuiFocusVisibleService, decorators: [{ type: Inject, args: [TuiFocusVisibleService,] }] }
];
__decorate([
    HostBinding('class._ios')
], TuiTabComponent.prototype, "isIos", void 0);
__decorate([
    HostBinding('class._android')
], TuiTabComponent.prototype, "isAndroid", void 0);
__decorate([
    HostBinding('class._focus-visible')
], TuiTabComponent.prototype, "focusVisible", void 0);
__decorate([
    HostBinding('class._active')
], TuiTabComponent.prototype, "isActive", null);
TuiTabComponent = __decorate([ __param(0, Optional()),
    __param(0, Inject(RouterLinkActive)),
    __param(1, Inject(ElementRef)),
    __param(2, Inject(TUI_MODE)),
    __param(3, Inject(TUI_TAB_EVENT)),
    __param(4, Inject(TUI_TAB_MARGIN)),
    __param(5, Inject(TUI_MOBILE_AWARE)),
    __param(6, Inject(TUI_IS_IOS)),
    __param(7, Inject(TUI_IS_ANDROID)),
    __param(8, Inject(TuiFocusVisibleService))
], TuiTabComponent);

const TUI_TABS_DEFAULT_OPTIONS = {
    underline: true,
    exposeActive: true,
    itemsLimit: Infinity,
};
const TUI_TABS_OPTIONS = new InjectionToken('Default parameters for tabs component', {
    factory: () => TUI_TABS_DEFAULT_OPTIONS,
});
const tuiTabsOptionsProvider = (options) => ({
    provide: TUI_TABS_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_TABS_DEFAULT_OPTIONS), options),
});

const TAB_ACTIVE_CLASS = '_active';
// TODO: remove in ivy compilation
const OBSERVER_INIT = {
    childList: true,
};
// @dynamic
let TuiTabsComponent = class TuiTabsComponent {
    constructor(options, elementRef, renderer, changeDetectorRef, resize$, isIos, isAndroid, mobileAware) {
        this.options = options;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.children = EMPTY_QUERY;
        this.underline = this.options.underline;
        this.activeItemIndexChange = new EventEmitter();
        this.activeItemIndex = 0;
        this.isIos = mobileAware && isIos;
        this.isAndroid = mobileAware && isAndroid;
        resize$.pipe(filter(() => this.underline)).subscribe(() => {
            changeDetectorRef.detectChanges();
        });
    }
    set activeItemIndexSetter(index) {
        this.activeItemIndex = index;
        this.scrollTo(this.tabs[index]);
    }
    get tabs() {
        return Array.from(this.elementRef.nativeElement.querySelectorAll('[tuiTab]'));
    }
    get activeElement() {
        return this.tabs[this.activeItemIndex] || null;
    }
    onActivate(element) {
        const index = this.tabs.findIndex(tab => tab === element);
        if (index === this.activeItemIndex) {
            return;
        }
        this.activeItemIndexSetter = index;
        this.activeItemIndexChange.emit(index);
    }
    onKeyDownArrow(current, step) {
        const { tabs } = this;
        moveFocus(tabs.indexOf(current), tabs, step);
    }
    ngAfterViewChecked() {
        const { tabs, activeElement } = this;
        tabs.forEach(nativeElement => {
            this.renderer.removeClass(nativeElement, TAB_ACTIVE_CLASS);
            this.renderer.setAttribute(nativeElement, 'tabIndex', '-1');
        });
        if (activeElement) {
            this.renderer.addClass(activeElement, TAB_ACTIVE_CLASS);
            this.renderer.setAttribute(activeElement, 'tabIndex', '0');
        }
    }
    scrollTo(element) {
        if (!element) {
            return;
        }
        const { offsetLeft, offsetWidth } = element;
        const { nativeElement } = this.elementRef;
        if (offsetLeft < nativeElement.scrollLeft) {
            nativeElement.scrollLeft = offsetLeft;
        }
        if (offsetLeft + offsetWidth >
            nativeElement.scrollLeft + nativeElement.offsetWidth) {
            nativeElement.scrollLeft =
                offsetLeft + offsetWidth - nativeElement.offsetWidth;
        }
    }
};
TuiTabsComponent.ɵfac = function TuiTabsComponent_Factory(t) { return new (t || TuiTabsComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_TABS_OPTIONS), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(Renderer2), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TuiResizeService), ɵngcc0.ɵɵdirectiveInject(TUI_IS_IOS), ɵngcc0.ɵɵdirectiveInject(TUI_IS_ANDROID), ɵngcc0.ɵɵdirectiveInject(TUI_MOBILE_AWARE)); };
TuiTabsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiTabsComponent, selectors: [["tui-tabs"], ["nav", "tuiTabs", ""]], contentQueries: function TuiTabsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiTabComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.children = _t);
    } }, hostVars: 6, hostBindings: function TuiTabsComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("tui-tab-activate.stop", function TuiTabsComponent_tui_tab_activate_stop_HostBindingHandler($event) { return ctx.onActivate($event.target); })("keydown.arrowRight.prevent", function TuiTabsComponent_keydown_arrowRight_prevent_HostBindingHandler($event) { return ctx.onKeyDownArrow($event.target, 1); })("keydown.arrowLeft.prevent", function TuiTabsComponent_keydown_arrowLeft_prevent_HostBindingHandler($event) { return ctx.onKeyDownArrow($event.target, -1); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_underline", ctx.underline)("_ios", ctx.isIos)("_android", ctx.isAndroid);
    } }, inputs: { underline: "underline", activeItemIndexSetter: ["activeItemIndex", "activeItemIndexSetter"] }, outputs: { activeItemIndexChange: "activeItemIndexChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            TuiDestroyService,
            TuiResizeService,
            MutationObserverService,
            {
                provide: MUTATION_OBSERVER_INIT,
                useValue: OBSERVER_INIT
            },
        ])], ngContentSelectors: _c1, decls: 4, vars: 4, consts: [[4, "ngIf"], [3, "element", 4, "ngIf"], [3, "element"]], template: function TuiTabsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiTabsComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, TuiTabsComponent_tui_underline_2_Template, 1, 1, "tui-underline", 1);
        ɵngcc0.ɵɵprojection(3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.children.changes));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.underline);
    } }, directives: function () { return [ɵngcc1.NgIf, TuiUnderlineComponent]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: ["[_nghost-%COMP%]{scrollbar-width:none;-ms-overflow-style:none;position:relative;display:flex;font:var(--tui-font-text-m);height:var(--tui-height-l);color:var(--tui-text-02);box-shadow:inset 0 -1px var(--tui-base-03);overflow:auto}[_nghost-%COMP%]::-webkit-scrollbar, [_nghost-%COMP%]::-webkit-scrollbar-thumb{background:0 0;width:0;height:0}._android[_nghost-%COMP%]{height:auto}._ios[_nghost-%COMP%]{height:auto;border:2px solid transparent;border-radius:.5625rem;background:var(--tui-link);box-shadow:none}"], changeDetection: 0 });
TuiTabsComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_TABS_OPTIONS,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Renderer2, decorators: [{ type: Inject, args: [Renderer2,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TuiResizeService,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_IOS,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_ANDROID,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_MOBILE_AWARE,] }] }
];
__decorate([
    ContentChildren(forwardRef(() => TuiTabComponent))
], TuiTabsComponent.prototype, "children", void 0);
__decorate([
    Input(),
    HostBinding('class._underline'),
    tuiDefaultProp()
], TuiTabsComponent.prototype, "underline", void 0);
__decorate([
    Input('activeItemIndex')
], TuiTabsComponent.prototype, "activeItemIndexSetter", null);
__decorate([
    Output()
], TuiTabsComponent.prototype, "activeItemIndexChange", void 0);
__decorate([
    HostBinding('class._ios')
], TuiTabsComponent.prototype, "isIos", void 0);
__decorate([
    HostBinding('class._android')
], TuiTabsComponent.prototype, "isAndroid", void 0);
__decorate([
    HostListener(`${TUI_TAB_ACTIVATE}.stop`, ['$event.target'])
], TuiTabsComponent.prototype, "onActivate", null);
__decorate([
    HostListener('keydown.arrowRight.prevent', ['$event.target', '1']),
    HostListener('keydown.arrowLeft.prevent', ['$event.target', '-1'])
], TuiTabsComponent.prototype, "onKeyDownArrow", null);
TuiTabsComponent = __decorate([ __param(0, Inject(TUI_TABS_OPTIONS)),
    __param(1, Inject(ElementRef)),
    __param(2, Inject(Renderer2)),
    __param(3, Inject(ChangeDetectorRef)),
    __param(4, Inject(TuiResizeService)),
    __param(5, Inject(TUI_IS_IOS)),
    __param(6, Inject(TUI_IS_ANDROID)),
    __param(7, Inject(TUI_MOBILE_AWARE))
], TuiTabsComponent);

function tabsRefreshFactory(resize$, mutations$, destroy$, { body }, { nativeElement }, changeDetectorRef) {
    return merge(resize$, mutations$.pipe(tap(() => changeDetectorRef.detectChanges()))).pipe(
    // Ignoring cases when host is detached from DOM
    filter(() => body.contains(nativeElement)), debounceTime(0), startWith(null), takeUntil(destroy$));
}
// TODO: remove in ivy compilation
const MUTATION_CONFIG = {
    childList: true,
    subtree: true,
};
const TABS_REFRESH = new InjectionToken('Refresh stream');
const TABS_PROVIDERS = [
    TuiResizeService,
    TuiDestroyService,
    MutationObserverService,
    {
        provide: MUTATION_OBSERVER_INIT,
        useValue: MUTATION_CONFIG,
    },
    {
        provide: TABS_REFRESH,
        deps: [
            TuiResizeService,
            MutationObserverService,
            TuiDestroyService,
            DOCUMENT,
            ElementRef,
            ChangeDetectorRef,
        ],
        useFactory: tabsRefreshFactory,
    },
];

// @dynamic
let TuiTabsWithMoreComponent = class TuiTabsWithMoreComponent {
    constructor(options, margin, refresh$, elementRef, changeDetectorRef, moreWord$) {
        this.options = options;
        this.margin = margin;
        this.refresh$ = refresh$;
        this.elementRef = elementRef;
        this.changeDetectorRef = changeDetectorRef;
        this.moreWord$ = moreWord$;
        this.maxIndex = Infinity;
        this.moreContent = '';
        this.dropdownContent = '';
        this.underline = this.options.underline;
        this.activeItemIndex = 0;
        this.itemsLimit = this.options.itemsLimit;
        this.activeItemIndexChange = new EventEmitter();
        this.items = EMPTY_QUERY;
        this.open = false;
    }
    // TODO: Improve performance
    get tabs() {
        return Array.from(this.elementRef.nativeElement.querySelectorAll('[tuiTab]'));
    }
    get activeElement() {
        var _a;
        return this.options.exposeActive || this.lastVisibleIndex >= this.activeItemIndex
            ? this.tabs[this.activeItemIndex] || null
            : ((_a = this.moreButton) === null || _a === void 0 ? void 0 : _a.nativeElement) || null;
    }
    get isMoreVisible() {
        return this.lastVisibleIndex < this.items.length - 1;
    }
    get isMoreFocusable() {
        return !!this.moreButton && isNativeFocused(this.moreButton.nativeElement);
    }
    get isMoreActive() {
        return (this.open ||
            (!this.options.exposeActive && this.lastVisibleIndex < this.activeItemIndex));
    }
    get lastVisibleIndex() {
        if (this.itemsLimit + 1 >= this.items.length) {
            return this.maxIndex;
        }
        const offset = this.itemsLimit - 1 > this.activeItemIndex || !this.options.exposeActive
            ? 1
            : 2;
        return Math.min(this.itemsLimit - offset, this.maxIndex);
    }
    ngAfterViewInit() {
        this.refresh$
            .pipe(map(() => this.getMaxIndex()), filter(maxIndex => this.maxIndex !== maxIndex))
            .subscribe(maxIndex => {
            this.maxIndex = maxIndex;
            this.changeDetectorRef.detectChanges();
        });
    }
    onActiveItemIndexChange(activeItemIndex) {
        this.updateActiveItemIndex(activeItemIndex);
    }
    onClick(index) {
        this.open = false;
        this.focusMore();
        this.updateActiveItemIndex(index);
    }
    onArrowRight(event) {
        tuiAssertIsHTMLElement(event.target);
        if (isNativeFocused(event.target)) {
            this.focusMore();
        }
    }
    onArrowLeft() {
        const { tabs } = this;
        let index = tabs.length - 2;
        while (index >= 0) {
            setNativeFocused(tabs[index]);
            if (isNativeFocused(tabs[index])) {
                return;
            }
            index--;
        }
    }
    onWrapperArrow(event, wrapper, prev) {
        const button = event.target;
        const target = getClosestFocusable(button, prev, wrapper);
        if (target) {
            setNativeFocused(target);
        }
    }
    isOverflown(index) {
        return index !== this.activeItemIndex || !this.options.exposeActive;
    }
    shouldShow(index) {
        return index > this.lastVisibleIndex && this.isOverflown(index);
    }
    focusMore() {
        if (this.moreButton) {
            setNativeFocused(this.moreButton.nativeElement);
        }
    }
    getMaxIndex() {
        const { tabs, activeItemIndex, margin } = this;
        if (tabs.length < 2) {
            return 0;
        }
        const { clientWidth } = this.elementRef.nativeElement;
        const activeWidth = tabs[activeItemIndex] ? tabs[activeItemIndex].scrollWidth : 0;
        const moreWidth = tabs[tabs.length - 1].scrollWidth;
        let maxIndex = tabs.length - 2;
        let total = tabs.reduce((acc, { scrollWidth }) => acc + scrollWidth, 0) +
            maxIndex * margin -
            moreWidth;
        if (total <= clientWidth) {
            return Infinity;
        }
        while (maxIndex) {
            total -= tabs[maxIndex].scrollWidth + margin;
            maxIndex--;
            const activeDisplaced = this.options.exposeActive && activeItemIndex > maxIndex;
            const activeOffset = activeDisplaced ? activeWidth + margin : 0;
            const currentWidth = total + activeOffset + moreWidth + margin;
            // Needed for different rounding of visible and hidden elements scrollWidth
            const safetyOffset = toInt(this.maxIndex === maxIndex - 1);
            if (currentWidth + safetyOffset < clientWidth) {
                return maxIndex;
            }
        }
        return 0;
    }
    updateActiveItemIndex(activeItemIndex) {
        if (this.activeItemIndex === activeItemIndex) {
            return;
        }
        this.activeItemIndex = activeItemIndex;
        this.activeItemIndexChange.emit(activeItemIndex);
        this.maxIndex = this.getMaxIndex();
    }
};
TuiTabsWithMoreComponent.ɵfac = function TuiTabsWithMoreComponent_Factory(t) { return new (t || TuiTabsWithMoreComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_TABS_OPTIONS), ɵngcc0.ɵɵdirectiveInject(TUI_TAB_MARGIN), ɵngcc0.ɵɵdirectiveInject(TABS_REFRESH), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TUI_MORE_WORD)); };
TuiTabsWithMoreComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiTabsWithMoreComponent, selectors: [["tui-tabs-with-more"], ["nav", "tuiTabsWithMore", ""]], contentQueries: function TuiTabsWithMoreComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiTabDirective, 4, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, viewQuery: function TuiTabsWithMoreComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiTabComponent, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.moreButton = _t.first);
    } }, hostVars: 2, hostBindings: function TuiTabsWithMoreComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_underline", ctx.underline);
    } }, inputs: { moreContent: "moreContent", dropdownContent: "dropdownContent", underline: "underline", activeItemIndex: "activeItemIndex", itemsLimit: "itemsLimit" }, outputs: { activeItemIndexChange: "activeItemIndexChange" }, features: [ɵngcc0.ɵɵProvidersFeature(TABS_PROVIDERS)], decls: 13, vars: 15, consts: [[4, "ngIf"], [1, "t-wrapper"], [1, "t-tabs", 3, "underline", "activeItemIndex", "activeItemIndexChange", "keydown.arrowRight"], [4, "ngFor", "ngForOf"], [1, "t-more_wrapper", 3, "content", "open", "openChange"], ["tuiTab", "", 1, "t-more", 3, "tuiFocusable", "keydown.arrowLeft.prevent"], ["polymorpheus-outlet", "", 3, "content"], ["more", ""], ["dropdown", ""], [3, "element", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf", "ngIfElse"], ["hidden", ""], [3, "ngTemplateOutlet"], [4, "ngTemplateOutlet"], ["src", "tuiIconChevronDown", 1, "t-icon"], [1, "t-dropdown", 3, "keydown.arrowUp.prevent", "keydown.arrowDown.prevent"], ["element", ""], [3, "tui-tab-activate", 4, "ngFor", "ngForOf"], [3, "tui-tab-activate"], [3, "ngTemplateOutlet", 4, "ngIf"], [3, "element"]], template: function TuiTabsWithMoreComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiTabsWithMoreComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "tui-tabs", 2);
        ɵngcc0.ɵɵlistener("activeItemIndexChange", function TuiTabsWithMoreComponent_Template_tui_tabs_activeItemIndexChange_3_listener($event) { return ctx.onActiveItemIndexChange($event); })("keydown.arrowRight", function TuiTabsWithMoreComponent_Template_tui_tabs_keydown_arrowRight_3_listener($event) { return ctx.onArrowRight($event); });
        ɵngcc0.ɵɵtemplate(4, TuiTabsWithMoreComponent_ng_container_4_Template, 4, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "tui-hosted-dropdown", 4);
        ɵngcc0.ɵɵlistener("openChange", function TuiTabsWithMoreComponent_Template_tui_hosted_dropdown_openChange_5_listener($event) { return ctx.open = $event; });
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵlistener("keydown.arrowLeft.prevent", function TuiTabsWithMoreComponent_Template_button_keydown_arrowLeft_prevent_6_listener() { return ctx.onArrowLeft(); });
        ɵngcc0.ɵɵelement(7, "span", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, TuiTabsWithMoreComponent_ng_template_8_Template, 3, 5, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, TuiTabsWithMoreComponent_ng_template_10_Template, 3, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, TuiTabsWithMoreComponent_tui_underline_12_Template, 1, 1, "tui-underline", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(9);
        const _r4 = ɵngcc0.ɵɵreference(11);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 13, ctx.items.changes));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("underline", false)("activeItemIndex", ctx.activeItemIndex);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("t-overflown", !ctx.isMoreVisible);
        ɵngcc0.ɵɵproperty("content", ctx.dropdownContent || _r4)("open", ctx.open);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("_active", ctx.isMoreActive);
        ɵngcc0.ɵɵproperty("tuiFocusable", ctx.isMoreFocusable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("content", ctx.moreContent || _r2);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.underline);
    } }, directives: function () { return [ɵngcc1.NgIf, TuiTabsComponent, ɵngcc1.NgForOf, ɵngcc5.TuiHostedDropdownComponent, TuiTabComponent, ɵngcc4.TuiFocusableDirective, ɵngcc6.PolymorpheusOutletComponent, ɵngcc1.NgTemplateOutlet, ɵngcc5.TuiSvgComponent, TuiUnderlineComponent]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: ["[_nghost-%COMP%]{position:relative;display:flex;font:var(--tui-font-text-m);height:var(--tui-height-l);box-sizing:border-box;color:var(--tui-text-02);box-shadow:inset 0 -1px var(--tui-base-03);overflow:hidden}.t-wrapper[_ngcontent-%COMP%]{position:relative;display:flex}.t-tabs[_ngcontent-%COMP%]{height:inherit;font-size:inherit;font-weight:inherit;overflow:visible;box-shadow:none;color:inherit}.t-overflown[_ngcontent-%COMP%]{display:flex;margin:0;width:0;max-width:0;overflow:hidden;visibility:hidden}.t-more_wrapper[_ngcontent-%COMP%]{height:100%}.t-more[_ngcontent-%COMP%]{margin:0}.t-icon[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;margin-right:-.25rem;vertical-align:bottom}.t-icon_rotated[_ngcontent-%COMP%]{transform:rotate(180deg)}.t-dropdown[_ngcontent-%COMP%]{padding:.5rem 0}.t-dropdown[_ngcontent-%COMP%]     [tuiTab]{width:100%;height:2.75rem;justify-content:flex-start;margin:0;padding:0 1rem;color:var(--tui-text-02)}.t-dropdown[_ngcontent-%COMP%]     [tuiTab]:before{display:none}.t-dropdown[_ngcontent-%COMP%]     [tuiTab]._active, .t-dropdown[_ngcontent-%COMP%]     [tuiTab]:focus, .t-dropdown[_ngcontent-%COMP%]     [tuiTab]:hover{box-shadow:none;color:var(--tui-base-08);background:var(--tui-base-02)}"], changeDetection: 0 });
TuiTabsWithMoreComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_TABS_OPTIONS,] }] },
    { type: Number, decorators: [{ type: Inject, args: [TUI_TAB_MARGIN,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TABS_REFRESH,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_MORE_WORD,] }] }
];
__decorate([
    ViewChild(TuiTabComponent, { read: ElementRef })
], TuiTabsWithMoreComponent.prototype, "moreButton", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTabsWithMoreComponent.prototype, "moreContent", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTabsWithMoreComponent.prototype, "dropdownContent", void 0);
__decorate([
    Input(),
    HostBinding('class._underline'),
    tuiDefaultProp()
], TuiTabsWithMoreComponent.prototype, "underline", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTabsWithMoreComponent.prototype, "activeItemIndex", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTabsWithMoreComponent.prototype, "itemsLimit", void 0);
__decorate([
    Output()
], TuiTabsWithMoreComponent.prototype, "activeItemIndexChange", void 0);
__decorate([
    ContentChildren(TuiTabDirective, { read: TemplateRef })
], TuiTabsWithMoreComponent.prototype, "items", void 0);
TuiTabsWithMoreComponent = __decorate([ __param(0, Inject(TUI_TABS_OPTIONS)),
    __param(1, Inject(TUI_TAB_MARGIN)),
    __param(2, Inject(TABS_REFRESH)),
    __param(3, Inject(ElementRef)),
    __param(4, Inject(ChangeDetectorRef)),
    __param(5, Inject(TUI_MORE_WORD))
], TuiTabsWithMoreComponent);

let TuiUnderlineComponent = class TuiUnderlineComponent {
    constructor({ nativeElement }, ngZone, animationFrame$, mobileAware, ios, android, mode$) {
        this.ngZone = ngZone;
        this.animationFrame$ = animationFrame$;
        this.mobileAware = mobileAware;
        this.ios = ios;
        this.android = android;
        this.mode$ = mode$;
        this.element$ = new ReplaySubject(1);
        this.refresh$ = this.element$.pipe(switchMap(element => element
            ? this.animationFrame$.pipe(mapTo(element), tuiZonefree(this.ngZone))
            : of(null)), share());
        this.isIos = this.mobileAware && this.ios;
        this.isAndroid = this.mobileAware && this.android;
        this.transition$ = asCallable(this.element$.pipe(map(element => element && 'all'), debounceTime(50)));
        this.transform$ = asCallable(this.refresh$.pipe(map(element => element ? `translate3d(${px(element.offsetLeft)}, 0, 0)` : null)));
        this.width$ = asCallable(this.refresh$.pipe(map(element => (element === null || element === void 0 ? void 0 : element.clientWidth) || 0)));
        nativeElement['$.style.transitionProperty'] = this.transition$;
        nativeElement['$.style.transform'] = this.transform$;
        nativeElement['$.style.width.px'] = this.width$;
    }
    set element(element) {
        this.element$.next(element);
    }
};
TuiUnderlineComponent.ɵfac = function TuiUnderlineComponent_Factory(t) { return new (t || TuiUnderlineComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(NgZone), ɵngcc0.ɵɵdirectiveInject(ANIMATION_FRAME), ɵngcc0.ɵɵdirectiveInject(TUI_MOBILE_AWARE), ɵngcc0.ɵɵdirectiveInject(TUI_IS_IOS), ɵngcc0.ɵɵdirectiveInject(TUI_IS_ANDROID), ɵngcc0.ɵɵdirectiveInject(TUI_MODE)); };
TuiUnderlineComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiUnderlineComponent, selectors: [["tui-underline"]], hostVars: 4, hostBindings: function TuiUnderlineComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("$.data-mode.attr", function TuiUnderlineComponent___data_mode_attr_HostBindingHandler() { return ctx.mode$; })("$.style.transitionProperty", function TuiUnderlineComponent___style_transitionProperty_HostBindingHandler() { return ctx.transition$(); })("$.style.transform", function TuiUnderlineComponent___style_transform_HostBindingHandler() { return ctx.transform$(); })("$.style.width.px", function TuiUnderlineComponent___style_width_px_HostBindingHandler() { return ctx.width$(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_ios", ctx.isIos)("_android", ctx.isAndroid);
    } }, inputs: { element: "element" }, features: [ɵngcc0.ɵɵProvidersFeature([MODE_PROVIDER])], decls: 0, vars: 0, template: function TuiUnderlineComponent_Template(rf, ctx) { }, styles: ["[_nghost-%COMP%]{transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:absolute;left:0;height:100%;color:var(--tui-primary);transform:scale(0);box-shadow:inset 0 -.1875rem 0 -.0625rem;transition-property:none;pointer-events:none}._ios[_nghost-%COMP%]{border-radius:.4375rem;background:var(--tui-base-01);box-shadow:0 .1875rem .0625rem rgba(0,0,0,.04),0 .1875rem .5rem rgba(0,0,0,.12)}._android[_nghost-%COMP%]{box-shadow:inset 0 -.1875rem var(--tui-link)}[data-mode=onDark][_nghost-%COMP%]{color:var(--tui-text-01-night)}[data-mode=onLight][_nghost-%COMP%]{color:var(--tui-text-02)}"], changeDetection: 0 });
TuiUnderlineComponent.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: NgZone, decorators: [{ type: Inject, args: [NgZone,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [ANIMATION_FRAME,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_MOBILE_AWARE,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_IOS,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_ANDROID,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_MODE,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiUnderlineComponent.prototype, "element", null);
__decorate([
    HostBinding('class._ios')
], TuiUnderlineComponent.prototype, "isIos", void 0);
__decorate([
    HostBinding('class._android')
], TuiUnderlineComponent.prototype, "isAndroid", void 0);
__decorate([
    HostListener('$.style.transitionProperty')
], TuiUnderlineComponent.prototype, "transition$", void 0);
__decorate([
    HostListener('$.style.transform')
], TuiUnderlineComponent.prototype, "transform$", void 0);
__decorate([
    HostListener('$.style.width.px')
], TuiUnderlineComponent.prototype, "width$", void 0);
TuiUnderlineComponent = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(NgZone)),
    __param(2, Inject(ANIMATION_FRAME)),
    __param(3, Inject(TUI_MOBILE_AWARE)),
    __param(4, Inject(TUI_IS_IOS)),
    __param(5, Inject(TUI_IS_ANDROID)),
    __param(6, Inject(TUI_MODE))
], TuiUnderlineComponent);

let TuiTabsModule = class TuiTabsModule {
};
TuiTabsModule.ɵfac = function TuiTabsModule_Factory(t) { return new (t || TuiTabsModule)(); };
TuiTabsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiTabsModule });
TuiTabsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TuiHostedDropdownModule,
            TuiSvgModule,
            TuiFocusableModule,
            PolymorpheusModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTabDirective, [{
        type: Directive,
        args: [{
                selector: `ng-template[tuiTab]`
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Inject,
                args: [TemplateRef]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTabComponent, [{
        type: Component,
        args: [{
                selector: `a[tuiTab]:not([routerLink]), a[tuiTab][routerLink][routerLinkActive], button[tuiTab]`,
                template: "<ng-container *ngIf=\"event$ | async\"></ng-container>\n<span class=\"t-highlight\"><ng-content></ng-content></span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: TUI_TAB_PROVIDERS,
                host: {
                    '($.data-mode.attr)': 'mode$',
                    '[style.--tui-tab-margin.px]': 'margin',
                    type: 'button'
                },
                styles: [":host-context(._underline):hover{box-shadow:inset 0 -2px var(--tui-base-03)}:host{transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;position:relative;display:flex;flex-shrink:0;height:100%;box-sizing:border-box;justify-content:space-between;align-items:center;white-space:nowrap;cursor:pointer;outline:0;text-decoration:none;color:inherit;transition-property:color,box-shadow,opacity;margin-right:var(--tui-tab-margin,1.5rem)}:host:hover{color:var(--tui-text-01)}:host:disabled{opacity:var(--tui-disabled-opacity);pointer-events:none}:host:not([data-mode])._active{opacity:1;color:var(--tui-text-01);box-shadow:none}:host[data-mode=onDark]{color:rgba(255,255,255,.72)}:host[data-mode=onDark]._active,:host[data-mode=onDark]:hover{color:#fff}:host[data-mode=onDark]._focus-visible .t-highlight{background:var(--tui-clear-inverse);color:var(--tui-text-01)}:host[data-mode=onLight]{color:var(--tui-text-02)}:host[data-mode=onLight]._active,:host[data-mode=onLight]:hover{color:var(--tui-text-01)}:host[data-mode=onLight]._focus-visible .t-highlight{background:var(--tui-text-01);color:#fff}:host._focus-visible .t-highlight{background:var(--tui-selection)}:host._android{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;height:3rem;flex:1;flex-shrink:0;justify-content:center;margin:0;text-transform:uppercase;color:var(--tui-base-09);opacity:.5;font-size:.875rem;font-weight:500;letter-spacing:-.008125rem;font-family:-apple-system,BlinkMacSystemFont,Roboto,'Helvetica Neue',sans-serif}:host._android:hover{box-shadow:none}:host._android._active{opacity:1;color:var(--tui-base-09)}:host._android .t-highlight{width:auto}:host._ios{height:1.75rem;flex:1;flex-shrink:0;justify-content:center;margin:0;color:var(--tui-base-01);opacity:1;font-size:.8125rem;font-weight:500;letter-spacing:-.005rem;font-family:-apple-system,BlinkMacSystemFont,Roboto,'Helvetica Neue',sans-serif}:host._ios:hover{box-shadow:none}:host._ios._active{font-size:.875rem;font-weight:600;color:var(--tui-link)}:host._ios .t-highlight{width:auto}.t-highlight{display:inline-flex;width:100%;align-items:center;justify-content:inherit}.t-highlight ::ng-deep>*{flex-shrink:0}"]
            }]
    }], function () { return [{ type: ɵngcc2.RouterLinkActive, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RouterLinkActive]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [TUI_MODE]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [TUI_TAB_EVENT]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [TUI_TAB_MARGIN]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_MOBILE_AWARE]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_IOS]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_ANDROID]
            }] }, { type: ɵngcc4.TuiFocusVisibleService, decorators: [{
                type: Inject,
                args: [TuiFocusVisibleService]
            }] }]; }, { focusVisible: [{
            type: HostBinding,
            args: ['class._focus-visible']
        }], isIos: [{
            type: HostBinding,
            args: ['class._ios']
        }], isAndroid: [{
            type: HostBinding,
            args: ['class._android']
        }], isActive: [{
            type: HostBinding,
            args: ['class._active']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTabsComponent, [{
        type: Component,
        args: [{
                selector: 'tui-tabs, nav[tuiTabs]',
                template: "<ng-container *ngIf=\"children.changes | async\"></ng-container>\n<tui-underline\n    *ngIf=\"underline\"\n    [element]=\"activeElement\"\n></tui-underline>\n<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    TuiDestroyService,
                    TuiResizeService,
                    MutationObserverService,
                    {
                        provide: MUTATION_OBSERVER_INIT,
                        useValue: OBSERVER_INIT
                    },
                ],
                styles: [":host{scrollbar-width:none;-ms-overflow-style:none;position:relative;display:flex;font:var(--tui-font-text-m);height:var(--tui-height-l);color:var(--tui-text-02);box-shadow:inset 0 -1px var(--tui-base-03);overflow:auto}:host::-webkit-scrollbar,:host::-webkit-scrollbar-thumb{background:0 0;width:0;height:0}:host._android{height:auto}:host._ios{height:auto;border:2px solid transparent;border-radius:.5625rem;background:var(--tui-link);box-shadow:none}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_TABS_OPTIONS]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.Renderer2, decorators: [{
                type: Inject,
                args: [Renderer2]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [TuiResizeService]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_IOS]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_ANDROID]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_MOBILE_AWARE]
            }] }]; }, { children: [{
            type: ContentChildren,
            args: [forwardRef(() => TuiTabComponent)]
        }], underline: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._underline']
        }], activeItemIndexChange: [{
            type: Output
        }], isIos: [{
            type: HostBinding,
            args: ['class._ios']
        }], isAndroid: [{
            type: HostBinding,
            args: ['class._android']
        }], activeItemIndexSetter: [{
            type: Input,
            args: ['activeItemIndex']
        }], onActivate: [{
            type: HostListener,
            args: [`${TUI_TAB_ACTIVATE}.stop`, ['$event.target']]
        }], onKeyDownArrow: [{
            type: HostListener,
            args: ['keydown.arrowRight.prevent', ['$event.target', '1']]
        }, {
            type: HostListener,
            args: ['keydown.arrowLeft.prevent', ['$event.target', '-1']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTabsWithMoreComponent, [{
        type: Component,
        args: [{
                selector: 'tui-tabs-with-more, nav[tuiTabsWithMore]',
                template: "<ng-container *ngIf=\"items.changes | async\"></ng-container>\n<div class=\"t-wrapper\">\n    <tui-tabs\n        class=\"t-tabs\"\n        [underline]=\"false\"\n        [activeItemIndex]=\"activeItemIndex\"\n        (activeItemIndexChange)=\"onActiveItemIndexChange($event)\"\n        (keydown.arrowRight)=\"onArrowRight($event)\"\n    >\n        <ng-container *ngFor=\"let item of items; let index = index\">\n            <ng-container\n                *ngIf=\"index <= lastVisibleIndex; else hidden\"\n                [ngTemplateOutlet]=\"item\"\n            ></ng-container>\n            <ng-template #hidden>\n                <div [class.t-overflown]=\"isOverflown(index)\">\n                    <ng-container *ngTemplateOutlet=\"item\"></ng-container>\n                </div>\n            </ng-template>\n        </ng-container>\n    </tui-tabs>\n    <tui-hosted-dropdown\n        class=\"t-more_wrapper\"\n        [class.t-overflown]=\"!isMoreVisible\"\n        [content]=\"dropdownContent || dropdown\"\n        [(open)]=\"open\"\n    >\n        <button\n            tuiTab\n            class=\"t-more\"\n            [class._active]=\"isMoreActive\"\n            [tuiFocusable]=\"isMoreFocusable\"\n            (keydown.arrowLeft.prevent)=\"onArrowLeft()\"\n        >\n            <span\n                polymorpheus-outlet\n                [content]=\"moreContent || more\"\n            ></span>\n        </button>\n        <ng-template #more>\n            {{ moreWord$ | async }}\n            <tui-svg\n                src=\"tuiIconChevronDown\"\n                class=\"t-icon\"\n                [class.t-icon_rotated]=\"open\"\n            ></tui-svg>\n        </ng-template>\n    </tui-hosted-dropdown>\n    <ng-template #dropdown>\n        <div\n            #element\n            class=\"t-dropdown\"\n            (keydown.arrowUp.prevent)=\"onWrapperArrow($event, element, true)\"\n            (keydown.arrowDown.prevent)=\"onWrapperArrow($event, element, false)\"\n        >\n            <div\n                *ngFor=\"let item of items; let index = index\"\n                (tui-tab-activate)=\"onClick(index)\"\n            >\n                <ng-container\n                    *ngIf=\"shouldShow(index)\"\n                    [ngTemplateOutlet]=\"item\"\n                ></ng-container>\n            </div>\n        </div>\n    </ng-template>\n    <tui-underline\n        *ngIf=\"underline\"\n        [element]=\"activeElement\"\n    ></tui-underline>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: TABS_PROVIDERS,
                styles: [":host{position:relative;display:flex;font:var(--tui-font-text-m);height:var(--tui-height-l);box-sizing:border-box;color:var(--tui-text-02);box-shadow:inset 0 -1px var(--tui-base-03);overflow:hidden}.t-wrapper{position:relative;display:flex}.t-tabs{height:inherit;font-size:inherit;font-weight:inherit;overflow:visible;box-shadow:none;color:inherit}.t-overflown{display:flex;margin:0;width:0;max-width:0;overflow:hidden;visibility:hidden}.t-more_wrapper{height:100%}.t-more{margin:0}.t-icon{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;margin-right:-.25rem;vertical-align:bottom}.t-icon_rotated{transform:rotate(180deg)}.t-dropdown{padding:.5rem 0}.t-dropdown ::ng-deep [tuiTab]{width:100%;height:2.75rem;justify-content:flex-start;margin:0;padding:0 1rem;color:var(--tui-text-02)}.t-dropdown ::ng-deep [tuiTab]:before{display:none}.t-dropdown ::ng-deep [tuiTab]._active,.t-dropdown ::ng-deep [tuiTab]:focus,.t-dropdown ::ng-deep [tuiTab]:hover{box-shadow:none;color:var(--tui-base-08);background:var(--tui-base-02)}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_TABS_OPTIONS]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [TUI_TAB_MARGIN]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [TABS_REFRESH]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [TUI_MORE_WORD]
            }] }]; }, { moreContent: [{
            type: Input
        }], dropdownContent: [{
            type: Input
        }], underline: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._underline']
        }], activeItemIndex: [{
            type: Input
        }], itemsLimit: [{
            type: Input
        }], activeItemIndexChange: [{
            type: Output
        }], items: [{
            type: ContentChildren,
            args: [TuiTabDirective, { read: TemplateRef }]
        }], moreButton: [{
            type: ViewChild,
            args: [TuiTabComponent, { read: ElementRef }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiUnderlineComponent, [{
        type: Component,
        args: [{
                selector: 'tui-underline',
                template: '',
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [MODE_PROVIDER],
                host: {
                    '($.data-mode.attr)': 'mode$'
                },
                styles: [":host{transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:absolute;left:0;height:100%;color:var(--tui-primary);transform:scale(0);box-shadow:inset 0 -.1875rem 0 -.0625rem;transition-property:none;pointer-events:none}:host._ios{border-radius:.4375rem;background:var(--tui-base-01);box-shadow:0 .1875rem .0625rem rgba(0,0,0,.04),0 .1875rem .5rem rgba(0,0,0,.12)}:host._android{box-shadow:inset 0 -.1875rem var(--tui-link)}:host[data-mode=onDark]{color:var(--tui-text-01-night)}:host[data-mode=onLight]{color:var(--tui-text-02)}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.NgZone, decorators: [{
                type: Inject,
                args: [NgZone]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [ANIMATION_FRAME]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_MOBILE_AWARE]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_IOS]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_ANDROID]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [TUI_MODE]
            }] }]; }, { isIos: [{
            type: HostBinding,
            args: ['class._ios']
        }], isAndroid: [{
            type: HostBinding,
            args: ['class._android']
        }], transition$: [{
            type: HostListener,
            args: ['$.style.transitionProperty']
        }], transform$: [{
            type: HostListener,
            args: ['$.style.transform']
        }], width$: [{
            type: HostListener,
            args: ['$.style.width.px']
        }], element: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTabsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiHostedDropdownModule,
                    TuiSvgModule,
                    TuiFocusableModule,
                    PolymorpheusModule,
                ],
                declarations: [
                    TuiTabsWithMoreComponent,
                    TuiTabsComponent,
                    TuiTabComponent,
                    TuiUnderlineComponent,
                    TuiTabDirective,
                ],
                exports: [
                    TuiTabsWithMoreComponent,
                    TuiTabsComponent,
                    TuiTabComponent,
                    TuiTabDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiTabsModule, { declarations: function () { return [TuiTabsWithMoreComponent, TuiTabsComponent, TuiTabComponent, TuiUnderlineComponent, TuiTabDirective]; }, imports: function () { return [CommonModule,
        TuiHostedDropdownModule,
        TuiSvgModule,
        TuiFocusableModule,
        PolymorpheusModule]; }, exports: function () { return [TuiTabsWithMoreComponent, TuiTabsComponent, TuiTabComponent, TuiTabDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MUTATION_CONFIG, OBSERVER_INIT, TABS_PROVIDERS, TABS_REFRESH, TUI_TABS_DEFAULT_OPTIONS, TUI_TABS_OPTIONS, TUI_TAB_ACTIVATE, TUI_TAB_EVENT, TUI_TAB_PROVIDERS, TuiTabComponent, TuiTabDirective, TuiTabsComponent, TuiTabsModule, TuiTabsWithMoreComponent, TuiUnderlineComponent, tabActiveFactory, tabsRefreshFactory, tuiTabsOptionsProvider };

